import { gql } from 'graphql-tag'

export default gql`
  fragment GlobalDataBusinessTypeFragment on GlobalDataBusinessType {
    sys {
      id
    }
    internalName
    name
    icon
  }
`
